import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { actions } from '@/state/filterActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

type MealFilterProps = {
    onFilterChange: () => void;
};

const mealsDisplay: Record<string, string> = displayValues.amenities.meals;

export const MealFilter = ({ onFilterChange }: MealFilterProps) => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.meals);
    const checkboxValues = useSelector((s: PaleState) => s.filters.meals);

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxMeal(valueOrMap));
    };

    const hasOptions = useMemo(() => Array.isArray(facetList) && facetList.some((f) => Boolean(mealsDisplay[f.value])), [facetList]);

    return hasOptions ? (
        <CheckboxFilter
            id="mealFilter"
            label="Måltider"
            facetList={facetList}
            displayValues={mealsDisplay}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={onFilterChange}
        />
    ) : null;
};
